/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlUserResponse } from './ControlUserResponse';
import {
    ControlUserResponseFromJSON,
    ControlUserResponseFromJSONTyped,
    ControlUserResponseToJSON,
} from './ControlUserResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedUserResponse
 */
export interface ControlPaginatedUserResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedUserResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedUserResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedUserResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlUserResponse>}
     * @memberof ControlPaginatedUserResponse
     */
    results: Array<ControlUserResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedUserResponse interface.
 */
export function instanceOfControlPaginatedUserResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedUserResponseFromJSON(json: any): ControlPaginatedUserResponse {
    return ControlPaginatedUserResponseFromJSONTyped(json, false);
}

export function ControlPaginatedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlUserResponseFromJSON)),
    };
}

export function ControlPaginatedUserResponseToJSON(value?: ControlPaginatedUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlUserResponseToJSON)),
    };
}

